import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IComplianceData, IComplianceState } from "../@types/compliance";
import { IApiResponse } from "../@types/api-response";

const initialState: IComplianceState = {
  compliances: [],
  loading: false,
};

export const complianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {
    setCompliances: (
      state,
      action: PayloadAction<IApiResponse<IComplianceData>>,
    ) => {
      state.compliances = action.payload.data.process_requests;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setCompliances, setLoading } = complianceSlice.actions;

export default complianceSlice.reducer;
